/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterA = createReactComponent("square-letter-a", "IconSquareLetterA", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 16v-6a2 2 0 1 1 4 0v6", key: "svg-1" }],
  ["path", { d: "M10 13h4", key: "svg-2" }]
]);

export { IconSquareLetterA as default };
//# sourceMappingURL=IconSquareLetterA.js.map
